import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { getFile } from '@/store/files/actions';

import { Col, Layout, Row, Spin } from 'antd';
import CustomEmpty from '@/components/CustomEmpty';
import MaterialCard from '@/components/MaterialCard';

import { createSelector } from '@reduxjs/toolkit';
import classNames from 'classnames';
import { openDB } from 'idb';
import PropTypes from 'prop-types';

import css from './OfflineMaterials.module.scss';

import { COMPANY_IDB, IDB_NAME, TOPICS_IDB, TOPICS_IMAGES_IDB, USER_IDB } from '@/constants/IndexedDB';

const { Content } = Layout;

const OfflineMaterials = props => {
  const [dataIDB, setDataIDB] = useState({
    topics: [],
    user: {},
    company: {},
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getAllDataIDB();
    setIsLoading(true);
    // нужно будет пофиксить массив зависимостей!!!
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getAllDataIDB = async () => {
    const db = await openDB(IDB_NAME);
    if (
      !db ||
      (!db.objectStoreNames.contains(TOPICS_IDB) &&
        db.objectStoreNames.contains(USER_IDB) &&
        db.objectStoreNames.contains(COMPANY_IDB) &&
        db.objectStoreNames.contains(TOPICS_IMAGES_IDB))
    ) {
      return;
    }

    const topics = await db.getAll(TOPICS_IDB);
    const userFromIDB = await db.getAll(USER_IDB);
    const companyFromIDB = await db.getAll(COMPANY_IDB);
    const topicsImagesIDB = await db.getAll(TOPICS_IMAGES_IDB);

    const imagesMap = new Map(topicsImagesIDB.map(img => [img.id, img.value]));

    const topicsWithImageUrls = topics.map(topic => {
      const blob = imagesMap.get(topic.id);
      if (blob instanceof Blob) {
        topic.imageIDB = URL.createObjectURL(blob);
      }
      return topic;
    });

    setDataIDB({
      ...dataIDB,
      topics: topicsWithImageUrls,
      user: userFromIDB[0],
      company: companyFromIDB[0],
    });
    setIsLoading(false);
  };

  const topicCards =
    dataIDB.topics.length &&
    dataIDB.topics.map((topic, key) => {
      return (
        <Col key={`topic_${key}${topic.id}`} className={css['OfflineMaterials-material-card']}>
          <MaterialCard
            offline
            topic={topic}
            userTopicId={topic.id}
            currentUser={dataIDB.user}
            domainCompany={dataIDB.user.domainCompany}
          />
        </Col>
      );
    });

  const main = isLoading ? (
    <div className={css['OfflineMaterials-spinner-wrapper']}>
      <Spin size='large' />
    </div>
  ) : dataIDB.topics.length ? (
    topicCards
  ) : (
    <div className={css['OfflineMaterials-material-cards-customEmpty']}>
      <CustomEmpty description={props.t('noTopics')} />
    </div>
  );

  return (
    <Content className={css['OfflineMaterials']}>
      <Row>
        <Col
          className={classNames(
            [css['OfflineMaterials-header']],
            !topicCards?.length && [css['OfflineMaterials-header-emptyContent']]
          )}
        >
          <h1>{props.t('title')}</h1>
        </Col>
        <Col className={css['OfflineMaterials-material-cards']}>{main}</Col>
      </Row>
    </Content>
  );
};

OfflineMaterials.propTypes = {
  getFile: PropTypes.func,
};

const mapStateToProps = createSelector([], () => ({}));

const mapActionsToProps = {
  getFile,
};

export default connect(mapStateToProps, mapActionsToProps)(withTranslation('OfflineMaterials')(OfflineMaterials));
